/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_GInputs */

const en_tut_denah_g = /** @type {(inputs: Tut_Denah_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The default plan already has a lobby, team areas, a meeting room, a focus zone, and a lounge. Owners and admins can rearrange it to match how the team works — safely, because changes are made as a draft.`)
};

const id_tut_denah_g = /** @type {(inputs: Tut_Denah_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denah bawaan sudah berisi lobi, area tim, ruang rapat, zona fokus, dan lounge. Pemilik dan admin bisa menyusunnya ulang mengikuti cara kerja tim — dengan aman, karena perubahan dikerjakan sebagai draf.`)
};

/**
* | output |
* | --- |
* | "The default plan already has a lobby, team areas, a meeting room, a focus zone, and a lounge. Owners and admins can rearrange it to match how the team works ..." |
*
* @param {Tut_Denah_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_g = /** @type {((inputs?: Tut_Denah_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_g(inputs)
	return en_tut_denah_g(inputs)
});